import React, { Component } from 'react'
import { withRouteData } from 'react-static'
import { connect } from 'react-redux'

import { sortByKey } from 'utils'

// import SvgIcon from './SvgIcon'
// import FlagsTable from './FlagsTable'
import CatalogInlineSearch from './CatalogInlineSearch'
import ProviderAsAPICard from './ProviderAsAPICard'
import Loader from './Loader'

const searchableFields = ['name', 'vendor', 'description', 'id', 'api_id']

const isMatching = ({ integratedOnly, search, language }) => {
    const test = search.toLowerCase()
    const ok = line => line.toLowerCase().indexOf(test) !== -1

    return provider => {
        if (integratedOnly) {
            if (!provider.integrated) {
                return false
            }
        }

        // filter by language features

        if (language) {
            let found = false
            if (
                provider.supportedLanguages &&
                provider.supportedLanguages.length > 0
            ) {
                found =
                    provider.supportedLanguages.indexOf(language.value) !== -1
            }
            if (!found) {
                return false
            }
            // if found, filter further
        }

        // filter by search string

        if (!search) {
            return true
        }

        let found = false

        searchableFields.forEach(field => {
            if (!provider[field]) {
                // console.log(field, provider)
                return false
            }
            if (ok(provider[field])) {
                found = true
                return found
            }
        })

        return found
    }
}

class CatalogLight extends Component {
    render() {
        const {
            slug,
            intentProviders,
            catalogInlineSearch: { integratedOnly, search = '', language },
        } = this.props
        let availableProviders = []
        let loading = false
        if (intentProviders[slug]) {
            loading = intentProviders[slug].pending
            if (!loading) {
                availableProviders = intentProviders[slug].response || []
            }
        }
        const filteredProviders = availableProviders.filter(
            isMatching({ integratedOnly, search, language })
        )

        return (
            <section
                id="mt-catalog"
                className="section catalog-section catalog"
            >
                <div className="section__container container u-padding-bottom-0">
                    <div className="section__header">
                        <h2 className="section__title">API Catalog</h2>
                    </div>
                    <div className="section__content">
                        <div className="catalog__search">
                            <CatalogInlineSearch placeholder="Search for API providers, e.g. google" />
                        </div>
                        {/* <div className="catalog__bar">
                        <div className="button-group button-group--view-type">
                            <a
                                className="button button--geyser button--outline button--icon button--active"
                                href="/api-platform/api"
                                title="Grid"
                            >
                                <SvgIcon slug="grid" />
                            </a>
                            <a
                                className="button button--geyser button--outline button--icon"
                                href="/api-platform/api"
                                title="List"
                            >
                                <SvgIcon slug="list" />
                            </a>
                        </div>
                    </div> */}
                        {loading && <Loader style={{ textAlign: 'center' }} />}

                        <div className="catalog__results">
                            {!loading && filteredProviders.length < 1 && (
                                <h2
                                    className="section__title"
                                    style={{
                                        opacity: 0.5,
                                        padding: 16,
                                        textAlign: 'center',
                                    }}
                                >
                                    No such providers for now.
                                </h2>
                            )}
                            <div className="api-cards">
                                <div className="api-cards__list">
                                    {filteredProviders
                                        .sort(sortByKey('vendor'))
                                        .map((provider, idx) => (
                                            <ProviderAsAPICard
                                                key={idx}
                                                provider={provider}
                                            />
                                        ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <FlagsTable /> */}
            </section>
        )
    }
}

function mapStateToProps(state) {
    return {
        catalogInlineSearch: state.catalogInlineSearch || {},
        intentProviders: state.intentProviders || {},
    }
}

export default connect(mapStateToProps)(withRouteData(CatalogLight))



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/components/CatalogLight.jsx